import {
	Button,
	FormControl,
	FormLabel,
	Input,
	InputLabel,
	MenuItem,
	Select,
	TextareaAutosize,
} from "@mui/material";
import { developAxios } from "../../axios.config";
import { Store } from "react-notifications-component";
import { useMutation, useQuery } from "react-query";
import axios from "axios";
import React, { useEffect, useState } from "react";

type TdashboardTemplates = {
	name: string;
	_id: string;
};

const CreateDashboard = () => {
	const [logo, setLogo] = useState<File | null>(null);
	const [description, setDescription] = useState<string>("");
	const [logoUrl, setLogoUrl] = useState<string | null>(null);
	const [name, setName] = useState("");
	const [template, setTemplate] = useState<string>("");
	const [psId, setPsId] = useState<string>("");
	const [courseDeadline, setCourseDeadline] = useState<string>("");

	const { data: dashboardTemplates } = useQuery(
		["get", "dashboard-templates"],
		() => {
			return developAxios(localStorage.getItem("token") || "")
				.get<{ data: TdashboardTemplates[] }>(
					"/superadmin/course/dashboard-templates"
				)
				.then(({ data }) => data.data);
		}
	);

	const { data: projectSpecifications } = useQuery(
		["get", "project-specificiations"],
		() => {
			return developAxios(localStorage.getItem("token") || "")
				.get<{ data: { _id: string; name: string }[] }>(
					"/superadmin/project-specification"
				)
				.then(({ data }) => data.data);
		}
	);

	const { mutateAsync: uploadImage } = useMutation(async () => {
		if (!logo) return;
		const name_arr = logo.name.split(".");
		const type = name_arr[name_arr.length - 1];

		const { data } = await developAxios(
			localStorage.getItem("token") || ""
		).get<{
			data: { presignedUrl: string; url: string };
		}>("/superadmin/course/college-logo-presigned-url", {
			params: {
				fileType: type || "png",
			},
		});
		setLogoUrl(data.data.url);
		await axios.put(data.data.presignedUrl, logo);

		return data.data.url;
	});

	const { mutateAsync: createNewCourse } = useMutation(
		async () => {
			return developAxios(localStorage.getItem("token") || "").post(
				"/superadmin/course/create-new",
				{
					name,
					description,
					courseDeadline: new Date(courseDeadline),
					collegeLogo: logoUrl,
					projectSpecificationOrder: psId,
					dashboardTemplate: template,
				}
			);
		},
		{
			onError: (error: any) => {
				if (error.name === "AxiosError") {
					const error_message = error.response.data.message;
					notifyPopup(error_message, "danger");
				}
			},

			onSuccess: () => {
				notifyPopup("Dashboard created successfully", "success");
				setLogoUrl("");
				setLogo(null);
				setName("");
				setTemplate("");
				setPsId("");
				setCourseDeadline("");
				setDescription("");
			},
		}
	);

	useEffect(() => {
		if (!logo) return;
		console.log("uploading images");
		uploadImage();
	}, [logo, uploadImage]);

	function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
		e.preventDefault();
		createNewCourse();
	}

	function notifyPopup(backend_message: string, type: "success" | "danger") {
		Store.addNotification({
			title: type === "danger" ? "Error Occured" : "Success",
			message: backend_message,
			type: type,
			insert: "bottom",
			container: "bottom-right",
			animationIn: ["animate__animated", "animate__fadeIn"],
			animationOut: ["animate__animated", "animate__fadeOut"],
			dismiss: {
				duration: 3000,
				onScreen: true,
			},
		});
	}

	return (
		<form onSubmit={handleSubmit} className="space-y-4">
			<div className="flex gap-3 font-semibold">
				<span className="text-red-600">*</span>
				<span>- Required Fields</span>
			</div>
			<div className="flex gap-4 items-center">
				<FormLabel htmlFor="name">
					Dashboard Name
					<span className="text-red-600">*</span>
				</FormLabel>
				<Input
					id="name"
					value={name}
					onChange={(e) => setName(e.target.value)}
					required
				/>
			</div>
			<div className="flex gap-4 items-center">
				<FormLabel htmlFor="logo">
					Dashboard Logo
					<span className="text-red-600">*</span>
				</FormLabel>
				<input
					id="logo"
					type="file"
					onChange={(e) =>
						setLogo(e.target.files && e.target.files[0])
					}
					accept="image/*"
				/>
			</div>
			<div className="flex gap-4 items-center">
				<FormLabel htmlFor="course_deadline">
					Course Deadline
					<span className="text-red-600">*</span>
				</FormLabel>
				<input
					id="course_deadline"
					type="date"
					value={courseDeadline}
					onChange={(e) => setCourseDeadline(e.target.value)}
				/>
			</div>
			<div className="flex gap-4">
				<FormLabel htmlFor="logo"> Description </FormLabel>
				<TextareaAutosize
					maxRows={6}
					placeholder="Description regarding the course"
					className="border border-black"
					onChange={(e) => setDescription(e.target.value)}
					value={description}
				/>
			</div>
			<div className="flex gap-4 items-center">
				<FormControl fullWidth>
					<InputLabel id="dashboard-templates-dropdown">
						Select the dashboard template
						<span className="text-red-600">*</span>
					</InputLabel>
					<Select
						onChange={(e) => setTemplate(e.target.value as string)}
						value={template}
						required
						label="Select the dashboard template"
						className="w-80"
						labelId="dashboard-templates-dropdown"
					>
						{dashboardTemplates &&
							dashboardTemplates.map((val) => (
								<MenuItem key={val._id} value={val._id}>
									{val.name}
								</MenuItem>
							))}
					</Select>
				</FormControl>
			</div>
			<div className="flex gap-4 items-center">
				<FormControl fullWidth>
					<InputLabel id="project-specification-templates-dropdown">
						Select the Project Specification ID
						<span className="text-red-600">*</span>
					</InputLabel>
					<Select
						onChange={(e) => setPsId(e.target.value as string)}
						value={psId}
						label="Select the ProjectSpefication ID"
						className="w-80"
						labelId="project-specification-templates-dropdown"
					>
						{projectSpecifications &&
							projectSpecifications.map((val) => (
								<MenuItem key={val._id} value={val._id}>
									{val.name}
								</MenuItem>
							))}
					</Select>
				</FormControl>
			</div>
			<Button variant="contained" type="submit">
				Create Dashboard
			</Button>
		</form>
	);
};

export default CreateDashboard;
